import request from '../utils/request';

export function getCheckDoctorBinding (){
    return request({
        url: "/wxmanager/doctor/checkDoctorBinding",
        method:'post',
    });
}
export function postWxUserInfoVoData (){
    return request({
        url: "/wxmanager/doctor/getHospUserKePage",
        method:'post',
    });
}
export function postDoctorSummary (data){
    return request({
        url: "/wxmanager/doctor/saveDoctorSummary",
        method:'post',
        data,
    });
}
export function postDoctorWork (data){
    return request({
        url: "/wxmanager/doctor/addDoctorWork",
        method:'post',
        data,
    });
}
export function postGetDoctorWork(){
    return request({
        url: "/wxmanager/doctor/getDoctorWork",
        method:'post',
    });
}
export function postGetHospUserPage (){
    return request({
        url: "/wxmanager/doctor/getHospUserPage",
        method:'post',
    });
}
export function postGetHospBiPage (){
    return request({
        url: "/wxmanager/doctor/getHospBiPage",
        method:'post',
    });
}
export function postGetHospBiAgeRecent (){
    return request({
        url: "/wxmanager/doctor/getHospBiAgeRecent",
        method:'post',
    });
}
export function postGetHospBiRiskRecent (){
    return request({
        url: "/wxmanager/doctor/getHospBiRiskRecent",
        method:'post',
    });
}
export function postToDoctorData (){
    return request({
        url: "/wxmanager/doctor/pushDataToDoctor",
        method:'post',
    });
}